export default "/fonts/vendor/remixicon/remixicon.woff?8d09fa11700ed63cf96e1d1c038368f3";